import {getAxiosInstance} from "../../../np-rest/rest";
import {snackActions} from "../../../sc-utilities/SnackBar";

export const fetchSupportedClientTypeUsage = (params) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let listRes = await rest.post("supported-client-type/usage-list", params);
            if (listRes.data && listRes.data.succeeded) {
                return listRes.data.result.data;
            }
            snackActions.snackBar({
                message: `${listRes && listRes.data ? listRes.data.message : "Could not fetch client type usages."}`,
                options: {
                    variant: 'warning'
                }
            });
            return []

        } catch (error) {
            snackActions.snackBar({
                message: `${error && error.data ? error.data.message : "Internal server error. Please contact system administrator."}`,
                options: {
                    variant: 'error'
                }
            });
            return []
        }
    }
}